export const types = {
  INSTALLATIONS_REQUEST: 'INSTALLATIONS/INSTALLATIONS_REQUEST',
  INSTALLATIONS_SUCCESS: 'INSTALLATIONS/INSTALLATIONS_SUCCESS',
  INSTALLATIONS_FAILURE: 'INSTALLATIONS/INSTALLATIONS_FAILURE',
  UPDATE_INSTALLATIONS_REQUEST: 'INSTALLATIONS/UPDATE_INSTALLATIONS_REQUEST',
  UPDATE_INSTALLATIONS_SUCCESS: 'INSTALLATIONS/UPDATE_INSTALLATIONS_SUCCESS',
  UPDATE_INSTALLATIONS_FAILURE: 'INSTALLATIONS/UPDATE_INSTALLATIONS_FAILURE',
};

export const initialState = {
  error: null,
  isLoading: false,
  isUpdating: false,
  installationsByProvider: {},
  redirectUrl: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.INSTALLATIONS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.INSTALLATIONS_SUCCESS: {
      const { installations, provider } = action;
      return {
        ...state,
        isLoading: false,
        installationsByProvider: {
          ...state.installationsByProvider,
          [provider]: installations,
        },
      };
    }
    case types.INSTALLATIONS_FAILURE:
      return { ...state, isLoading: false, error: action.error };
    case types.UPDATE_INSTALLATIONS_REQUEST:
      return { ...state, isUpdating: true, error: null };
    case types.UPDATE_INSTALLATIONS_SUCCESS: {
      const { redirectUrl } = action;
      return { ...state, isUpdating: false, redirectUrl };
    }
    case types.UPDATE_INSTALLATIONS_FAILURE:
      return { ...state, isUpdating: false, error: action.error };
    default:
      return state;
  }
};

export const actions = {
  fetchInstallations: (provider) => ({
    type: types.INSTALLATIONS_REQUEST,
    provider,
  }),
  updateInstallation: (
    provider,
    providerId,
    allRepos,
    orgType,
    repositories
  ) => ({
    type: types.UPDATE_INSTALLATIONS_REQUEST,
    provider,
    providerId,
    allRepos,
    orgType,
    repositories,
  }),
};
